export default "__VITE_ASSET__BAfwqXU8__";